// extracted by css-extract-rspack-plugin
export default {"cls1":"VideoUnavailable-cls1_z_H","cls2":"VideoUnavailable-cls2_Iqj VideoUnavailable-cls1_z_H"};